// ©2024 Austin App House. All rights reserved.
import React, { useEffect } from 'react';
import Select from '../../CustomSelect';
import customSelectStyle, {
  dashboard,
  dashboardSearchable,
  dashboardSelectClassNames,
} from '../../../../utils/customSelectStyle';
import FieldLabel from '../../FieldLabel';

const ReactSelectField = (field) => {
  useEffect(() => {
    if (field?.input?.value?._id && !(field?.input?.value?.value && field?.input?.value?.label)) {
      field.input.onChange({
        value: field?.input?.value?._id,
        label: field?.input?.value?.name || field?.input?.value?.title,
      });
    } else if (field?.input?.value && (typeof field?.input?.value === 'string')) {
      field.input.onChange({
        value: field?.input?.value,
        label: field?.input?.value.replace(/^\w/, (c) => c.toUpperCase()),
      });
    }
  }, []);

  const wrapperClass = field.paddingBottomClassName === ''
    ? 'dashboard-field-control'
    : (field.paddingBottomClassName || 'padding-bottom-10');

  const selectStyles = field.styles
    || (field.dashboardStyle
      ? (field.isSearchable ? dashboardSearchable : dashboard)
      : customSelectStyle[field.customSelectStyleType || 'dark']);

  const selectClassNames = field.classNames
    || (field.dashboardStyle ? dashboardSelectClassNames : undefined);

  const selectValue = field.isMulti
    ? (field.input.value || [])
    : (field.input.value ?? null);

  return (
    <div className={wrapperClass}>
      {!field.dashboardStyle && (
        <div className={`flex-box justify-content-between ${field.className || ''}`}>
          <FieldLabel
            label={field.label}
            className={field.labelClassName}
            required={field.required}
          />
          <div className={field.inputClassName}>
            <Select
              inputId={field.inputId}
              name={field.input.name}
              value={selectValue}
              hideSelectedOptions={false}
              options={field.options}
              styles={selectStyles}
              classNames={selectClassNames}
              placeholder={field.placeholder}
              required={field.required}
              isLoading={field.isLoading}
              onChange={field.input.onChange}
              isDisabled={field.disabled}
              isClearable={field.isClearable}
              isSearchable={field.isSearchable}
              isMulti={field.isMulti}
            />
          </div>
        </div>
      )}
      {field.dashboardStyle && (
        <div className="field_block dashboard-select-wrap">
          <Select
            inputId={field.inputId}
            name={field.input.name}
            value={selectValue}
            hideSelectedOptions={false}
            options={field.options}
            styles={selectStyles}
            classNames={selectClassNames}
            placeholder={field.placeholder}
            required={field.required}
            isLoading={field.isLoading}
            onChange={field.input.onChange}
            isDisabled={field.disabled}
            isClearable={field.isClearable}
            isSearchable={field.isSearchable}
            isMulti={field.isMulti}
          />
        </div>
      )}
      {
        field.meta.touched && field.meta.error
        && <span className="span-error">{field.meta.error}</span>
      }
    </div>
  );
};

export default ReactSelectField;
